import {CopilotCodeReviewFindings} from '@github-ui/copilot-code-review-findings'
import {useRouteQuery, useSuspenseRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {PageLayout} from '@primer/react'
import {PullRequestStoreProvider} from '../stores/PullRequestStore'
import {pullRequestsFindingsRoute} from './findings-route'

export function FindingsEntrypoint() {
  const {data: findings} = useRouteQuery(pullRequestsFindingsRoute, 'mainQuery')
  const {data: baseComparisonInfo} = useSuspenseRouteQuery(pullRequestsFindingsRoute, 'base_comparison_info')

  return (
    <PageLayout.Content as="div" padding="normal" width="full">
      <PullRequestStoreProvider initData={baseComparisonInfo}>
        <CopilotCodeReviewFindings {...findings} />
      </PullRequestStoreProvider>
    </PageLayout.Content>
  )
}
